export default "__VITE_ASSET__25ee93d5__"